import toNumber from 'lodash/toNumber';
import { validateMeterInputValue } from 'utils';
import { Stepper } from 'components/ui';
import { ResetBadge, ReturnIcon, StyledInputWrapper } from './meter-input.styled';

interface Props {
  currentValue: string;
  initialValue: number;
  meterType: string;
  isDisabled: boolean;
  changeReading: (arg0: string) => void;
  isReadingsChanged: boolean;
}

export const MeterInput = ({
  currentValue,
  initialValue,
  meterType,
  isDisabled,
  changeReading,
  isReadingsChanged,
}: Props) => {
  const isHeatMeter = meterType === 'HeatAreaMeter';

  return (
    <StyledInputWrapper isReadingsChanged={isReadingsChanged}>
      <ResetBadge
        isShow={isReadingsChanged}
        onClick={() => changeReading(String(initialValue))}
      >
        <ReturnIcon />
      </ResetBadge>

      <Stepper
        value={toNumber(currentValue)}
        onChange={(value) =>
          changeReading(validateMeterInputValue(String(value), isHeatMeter))
        }
        min={0}
        max={99999}
        step={1}
        disabled={isDisabled}
        decimals={isHeatMeter ? 3 : 0}
      />
    </StyledInputWrapper>
  );
};
